/*
 * @Date: 2022-03-31 14:53:19
 * @LastEditTime: 2022-04-15 14:01:58
 * @Description: file content
 * @FilePath: \traffic\src\components\show\show.jsx
 */
import React from 'react'

/**
 * @description 展示组件
 * @param { boolean } show true时展示children, false时不展示children
 * @param { React.ReactComponentElement } render false自定义展示
 * */ 
export default function Show({ children, show, render }) {
  return( (show && children) ? children : render ? render : <></> )
}
